import React, {useState} from "react";
import { colors, Flex, MyCampo} from "../../../ui";
import MyRadio from "../../../Helpers/Radios";
import styled from "@emotion/styled";
import {Mycheck} from "../../index";
import {ValorC} from "../helper";
import {BtnLine} from "../styles";
import {Btn} from "../../../UI-Components/Btn";

const Container = styled.div`
    position:relative;
    width:100%;
    
    .showInfo{
        cursor:pointer;
        &:hover{
            text-decoration:underline;
        }
    }
   
    .contenedorBlanco{
        position:relative;
        background:white;
        border-radius:10px;
        overflow:hidden;
        
        @media all and (max-width: 991px){
             border-radius:5px 5px 0 0;
             padding-bottom:15px;
        }
    }
    
    @media all and (max-width: 991px){
             .contBtn{
                button{
                    padding:15px;
                    border-radius:0  0 5px 5px!important;
                }
             }
        }
        
     @media all and (min-width: 991px){
        .otroVal{
           display:none;
        }
     }
`;

function FacturaC2({
    props,fac,id
                   }) {
    const [state,setState] = useState({
        otroValor:false,
    });


    let fId    = fac.filter(item=> item.entidad === "facturaId" );
    let Montos = fac.filter(item=> item.entidad !== "facturaId" );

    // ESCUCHA EN ONLICK Y SETEA EL VALOR AL PADRE
    let seteValue = (entitie,ID)=>{
        let valor = {target:{value:ID}};
        let Metodos = {
            total:(val)=> props.clickCheckValor1(val),
            segundoTotal:(val)=> props.clickCheckValor2(val),
            tercerTotal:(val)=> props.clickCheckValor3(val),
        };
        return Metodos.hasOwnProperty(entitie) ? Metodos[entitie](valor) : null;
    };

    // VALIDA SI DEBERIA ESTAR CHULUEADO
    let chuleados = (entitie)=> {
        let validaciones = {
            total: props[`checksValor2`].length > 0 && props[`checksValor1`][id],
            segundoTotal: props[`checksValor2`].length > 0 && props[`checksValor2`][id],
            tercerTotal: props[`checksValor2`].length > 0 && props[`checksValor3`][id]
        };
        return validaciones[entitie];
    };

    let resetaOtroValor = ()=> PROPS.onChangeOtroValor("",id);

    let PROPS = props;

    return (
        <Container>
            <Flex className={"mb-3 wc "} alg="stretch" key={"factura" + id} jc={"flex-start"}>
                <Flex className={"col-12 col-lg-10 pl-0 contenedorBlanco"}
                      alg={"stretch"}
                      jc={"flex-start"}
                      elastic={"1 0 90%"}
                >
                    <Flex direction={"colunm"} elastic={"0 0 50px"}>
                        <Mycheck
                            active={props.checks.length > 0 ? props.checks[id] : false}
                            clickCheck={props.clickCheck.bind(this)} value={id}
                        />
                    </Flex>
                    <Flex jc={"flex-start"} alg={"flex-end"} elastic={"1 0 80%"} className={"position-relative"}>

                            {fId.map((it, key2) =>
                                <Flex
                                    key={"it" + key2}
                                    elastic={"0 0 100%"}
                                    className={"py-2 pt-lg-1  pb-lg-0 "}
                                >
                                    <div onClick={() => props.showModal(id)} className={"wc showInfo"}>
                                        <Flex>
                                            <Flex direction={"colunm"} elastic={"0 0 30px"} >
                                                <i
                                                    style={{color: "#40A8E6"}}
                                                    className={`fa fa-info-circle fa-md`}
                                                />
                                            </Flex>
                                            <Flex className={"text-left "} jc={"flex-start"}
                                                  elastic={"1 0 100px"}>
                                                {props.tituloFactura === it.titulo &&
                                                <MyRadio color="primary"
                                                         name={'MyRadio'}
                                                         onChange={props.clickCheck.bind(this)}
                                                         checked={props.checks.length > 0 ? props.checks[id] : false}
                                                         value={id}
                                                />
                                                }
                                                <p className={"mb-0 description"}>
                                                    <b style={{fontSize: "13px"}}>{it.titulo}:</b>
                                                    <span className={"cg"}> {it.valor} </span>
                                                </p>
                                            </Flex>
                                        </Flex>
                                    </div>
                                </Flex>
                            )}

                        <Flex
                            className={`px-0 position-relative`}
                            elastic={"1 0 145px "}
                        >
                            <Flex jc={"flex-start"} className={"wc"}>
                                {Montos.map((it, key2) =>
                                    <ValorC
                                        nameValue={it.titulo}
                                        value={it.valor}
                                        currency={""}
                                        flex={"1 0 150px"}
                                        active={chuleados(it.entidad)}
                                        onClick={()=> {
                                            resetaOtroValor();
                                            seteValue(it.entidad,id);
                                        }}
                                        currencySymbol={""}
                                        key={"it" + key2}
                                    />
                                )}

                                <ValorC
                                    nameValue={"Otro valor"}
                                    value={PROPS.valuesOtroValor[id]}
                                    flex={"1 0 150px"}
                                    active={PROPS.valuesOtroValor[id] !== 0}
                                    onChange={(e)=>  PROPS.onChangeOtroValor(Number(e),id) }
                                    currencySymbol={""}
                                    input
                                />


                                {/*<CustomInput*/}
                                {/*    className={"otroVal"}*/}
                                {/*    flex={"1 0 150px"}*/}
                                {/*>*/}
                                {/*    <MyCampo*/}
                                {/*        label={"Otro monto"}*/}
                                {/*        type="mount"*/}
                                {/*        placeholder={"Otro valor"}*/}
                                {/*        value={PROPS.valuesOtroValor[id]}*/}
                                {/*        name={id}*/}
                                {/*        onChangeValor={PROPS.onChangeOtroValor.bind(this)}*/}
                                {/*        obligatory={false}*/}
                                {/*        // disabled={!props.checksOtroValor[id]}*/}
                                {/*        bordeAzul={true}*/}
                                {/*        flex={"1 0 100%"}*/}
                                {/*    />*/}
                                {/*</CustomInput>*/}
                            </Flex>
                        </Flex>



                        {props.opcionesRecaudo.modificarValorPagar.activo &&
                            <Flex elastic={"0 0 120px"} className={"px-1 d-none  pb-2 "}>
                                <BtnLine
                                    className={"wc"}
                                    type={"button"}
                                    brd={colors.btn}
                                    br={"8px"}
                                    onClick={() => {
                                        // props.clickCheckOtroValor.bind(this);
                                        setState({...state,otroValor:!state.otroValor});
                                        resetaOtroValor();
                                        // clickCheckOtroValor()
                                    }}
                                >
                                    {state.otroValor ? "Volver" : "Otros valor"}
                                </BtnLine>
                            </Flex>
                        }
                        <Flex
                            className={`
                            px-2 py-2 py-md-0 pb-md-1 text-center dato d-none
                            ${props.opcionesRecadudo.multiplesValoresPago.opcion !== "3" && "lineUp"}`}
                            elastic={"0 0 158px"}
                        >
                            <div className={"wc text-center"}>
                                <MyRadio
                                    color="primary"
                                    // name={props.opcionesRecaudo.modificarValorPagar.activo}
                                    onChange={props.clickCheckOtroValor.bind(this)}
                                    checked={props.checksOtroValor.length > 0 ? props.checksOtroValor[id] : false}
                                    value={id}
                                />
                            </div>
                            <div className={"wc"}>
                                <b style={{fontSize: "13px"}}>Otro valor </b>
                            </div>
                            <MyCampo
                                type="mount"
                                placeholder={"Otro valor"}
                                value={props.valuesOtroValor[id]}
                                name={id}
                                onChangeValor={props.onChangeOtroValor.bind(this)}
                                obligatory={false}
                                // disabled={!props.checksOtroValor[id]}
                                bordeAzul={true}
                                flex={"1 0 100%"}
                            />
                        </Flex>
                    </Flex>
                </Flex>

                <Flex
                    className="contBtn col-12 col-lg-2 px-0 px-lg-2"
                    elastic={"1 0 90px"}
                >
                    <Btn onClick={() => props.pagar(id)}
                         brdr={"12px"}
                         hg={"100%"}
                         className={"hc"}
                    >
                        PAGAR
                    </Btn>
                </Flex>
            </Flex>
        </Container>
    )
}

export default React.memo(FacturaC2);
